import { Box, Flex, Skeleton } from '@radix-ui/themes';

interface SkeletonLoaderProps {
  /** Número de linhas a simular. */
  rows?: number;
  /** Número de colunas a simular. */
  columns?: number;
}

/**
 * Esqueleto com a forma de uma listagem (barra de acções + tabela), para que
 * o carregamento não provoque salto de layout quando os dados chegam.
 */
const SkeletonLoader = ({ rows = 6, columns = 4 }: SkeletonLoaderProps) => {
  return (
    <Flex direction="column" gap="4" aria-busy="true" aria-live="polite">
      <Flex justify="between" align="center" gap="3">
        <Skeleton width="220px" height="var(--space-6)" />
        <Skeleton width="120px" height="var(--space-6)" />
      </Flex>

      <Box
        style={{
          border: '1px solid var(--gray-5)',
          borderRadius: 'var(--radius-3)',
          overflow: 'hidden',
        }}
      >
        <Flex gap="4" p="3" style={{ backgroundColor: 'var(--gray-2)' }}>
          {[...Array(columns)].map((_, i) => (
            <Skeleton key={`h-${i}`} height="var(--space-4)" style={{ flex: 1 }} />
          ))}
        </Flex>

        {[...Array(rows)].map((_, r) => (
          <Flex
            key={`r-${r}`}
            gap="4"
            p="3"
            style={{ borderTop: '1px solid var(--gray-4)' }}
          >
            {[...Array(columns)].map((_, c) => (
              <Skeleton key={`c-${r}-${c}`} height="var(--space-4)" style={{ flex: 1 }} />
            ))}
          </Flex>
        ))}
      </Box>
    </Flex>
  );
};

export default SkeletonLoader;
